import { z } from 'zod';

export const palletFormSchema = z.object({
  transportUnitNumber: z
    .string()
    .max(50, 'Transport unit number must be 50 characters or less')
    .optional()
    .or(z.literal('')),
  type: z.string().optional().or(z.literal('')),
  inventoryUnit: z.string().optional().or(z.literal('')),
  length: z
    .number({ required_error: 'Length is required' })
    .min(0.01, 'Length must be at least 0.01')
    .max(9999.99, 'Length must be at most 9999.99')
    .optional()
    .or(z.nan()),
  width: z
    .number({ required_error: 'Width is required' })
    .min(0.01, 'Width must be at least 0.01')
    .max(9999.99, 'Width must be at most 9999.99')
    .optional()
    .or(z.nan()),
  height: z
    .number({ required_error: 'Height is required' })
    .min(0.01, 'Height must be at least 0.01')
    .max(9999.99, 'Height must be at most 9999.99')
    .optional()
    .or(z.nan()),
  maxWeight: z
    .number({ required_error: 'Max weight is required' })
    .min(0.01, 'Max weight must be at least 0.01')
    .max(999999.99, 'Max weight must be at most 999999.99')
    .optional()
    .or(z.nan())
});

export type PalletFormSchema = z.infer<typeof palletFormSchema>;
